module.exports = __webpack_public_path__ + "img/martin-adams-6Gsq3DxFdCQ-unsplash.be4ddde0.jpg";